import React from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';
import { ENDERECOS_EXCLUIR } from '../../../../services/endereco';

function FormExcluirEndereco({
  acaoCancelar,
  acaoFechar,
  idCorreios,
  enderecoSelecionado,
  enderecos,
}) {
  const { t } = useTranslation();
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      ENDERECOS_EXCLUIR(idCorreios, enderecoSelecionado.idEndereco),
    );

    if (response.ok) {
      abreAlertaDialog(t('principal.addresses.messages.deleted_success'));
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>{t('principal.addresses.delete_confirmation', { name: enderecoSelecionado?.identificacao })}</h2>
        </div>
        {enderecos?.length === 1 ? (
          <div className="dialog-main" id="dialog-main-email">
            <p>
              {t('principal.addresses.delete_last_warning')}
            </p>
          </div>
        ) : (
          <div className="dialog-main" id="dialog-main-email">
            {t('principal.addresses.delete_confirmation_question')}
          </div>
        )}
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            {t('principal.forms.buttons.cancel')}
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            {t('principal.addresses.delete')}
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirEndereco;
